import React, { Component } from 'react'
import PropTypes from 'prop-types'
import formatter from '../../util/formatter'

import './styles.css'

export default class Button extends Component {
  render () {
    const { children, className, ghost, feedback = false } = this.props
    const properties = { ...this.props }
    delete properties.ghost
    delete properties.feedback
    properties.className = formatter.toClassName(['wd-button', ghost ? 'button-ghost' : '', className])

    return (
      <button {...properties} disabled={feedback}>{ !feedback ? children : <img src='/icon/button-loading.svg' alt='loading' />}</button>
    )
  }
}

Button.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  ghost: PropTypes.bool,
  onclick: PropTypes.func,
  loading: PropTypes.bool
}
